module.exports = __webpack_public_path__ + "d05147cccfc41d1d14d692b4d9db664b.svg";